import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "emptyState"
  }, [_c(VIcon, {
    staticStyle: {
      "border": "2px solid currentColor",
      "width": "100px",
      "height": "100px",
      "padding": "24px",
      "border-radius": "50%"
    },
    attrs: {
      "size": "48",
      "color": _vm.color
    }
  }, [_vm._v("\n    far " + _vm._s(_vm.icon) + "\n  ")]), _c('h2', {
    staticClass: "mt-5 mb-3"
  }, [_vm._t("title", function () {
    return [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")];
  })], 2), _vm._t("description", function () {
    return [_vm._v("\n    " + _vm._s(_vm.description) + "\n  ")];
  }), _vm._t("default"), _vm._t("button", function () {
    return [typeof _vm.$listeners['click:button'] === 'function' ? _c('core-button', {
      staticClass: "mt-4",
      attrs: {
        "color": _vm.color,
        "data-cy": "empty-state-button",
        "disabled": _vm.buttonDisabled,
        "append-icon": "fa-plus"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('click:button');
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.buttonLabel || _vm.$i18n_t('Core.EmptyState.button.label')) + "\n    ")]) : _vm._e()];
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };